import moment from 'moment';

export function formatTime (time) {
  if (!time) return '';
  return moment(Number(time)).format('HH:mm');
}

export function formatTimeRange (time) {
  if (!time) return '';
  return `${moment(Number(time)).format('HH:mm')} - ${moment(Number(time))
    .add(15, 'minutes')
    .format('HH:mm')}`;
}
